import { isLocationTypeState } from 'features/searchResultsFacets';
import { store } from '@redux/store';
import { LeadPages, StateLeadPages } from '../constants/leadPages';

/**
 * Resolves the `data-from-page` lead source value for a map pin summary card.
 *
 * On state search results pages (for example /communities/tx) leads must be
 * attributed to the state specific lead pages rather than the generic
 * market level ones. The card components render on the client, so the page
 * type is read from the Redux store using the same selector the rest of the
 * search results page uses.
 *
 * @param {Object|string} cardType - The map card listing type.
 * @param {Object|string} variant - The listing variant.
 * @returns {string} The lead source page value for the current page.
 */
export default function getMapCardLeadPage(cardType, variant) {
  const leadPages = isLocationTypeState(store.getState()) ? StateLeadPages : LeadPages;
  const cardTypeKey = cardType.toString();
  const variantKey = variant.toString();

  return leadPages[cardTypeKey][variantKey];
}
